// extracted by mini-css-extract-plugin
module.exports = {"skusContainer":"ManageSkus_skusContainer_2-3uN"};